import React from 'react';
import styled from 'styled-components';
import Time from './Events__Time';
import iconSVG from '../data/images/map.svg';

import { fadeOut, colors, padding, fonts } from '../GlobalStyle';
import { calc4k } from '../utilities';

export default function Showcase({ currEvent, currStep, images }) {
    const getKey = () => (currStep < 5 ? Math.random() : undefined);
    const imageOpacity = idx => {
        if (idx === 0 && currStep > 5) {
            return 1;
        }

        return idx === images.length - currStep ||
            idx > images.length - currStep
            ? '0'
            : '1';
    };

    return (
        <Wrapper>
            <ImagesContainer>
                {images.map((img, idx) => (
                    <Image src={img} key={idx} opacity={imageOpacity(idx)} />
                ))}
                <DataContainer>
                    <Time
                        key={getKey()}
                        time={currEvent.displayTime}
                        period={currEvent.displayTimePeriod}
                    />
                    <Type key={getKey()}>{currEvent.type}</Type>
                    <Title key={getKey()}>{currEvent.title}</Title>
                    {currEvent?.location ? (
                         <Location key={getKey()}>
                            <Icon src={iconSVG} />
                            {currEvent.location}
                        </Location>
                    ) : null}                   
                </DataContainer>
            </ImagesContainer>
        </Wrapper>
    );
}

const Location = styled.div`
    margin-top: ${calc4k(60)};
    color: #ffffff;
    font-family: ${fonts.body};
    font-size: ${calc4k(46)};
    line-height: ${calc4k(72)};
    font-weight: 500;
    animation: ${fadeOut} 1200ms ease-in-out;
`;

const Icon = styled.img`
    height: ${calc4k(40)};
    width: auto;
    margin-right: ${calc4k(19)};
`;

const Wrapper = styled.div`
    position: relative;
    height: ${calc4k(1916)};
`;

const ImagesContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
`;

const DataContainer = styled.div`
    padding-left: ${padding.side};
    padding-right: ${calc4k(703)};
`;

const Image = styled.img`
    position: absolute;
    width: 100%;
    height: 100%;
    transition: opacity 600ms ease-in-out;
    opacity: ${p => p.opacity};
    z-index: -1;
`;

export const Type = styled.p`
    margin-top: ${calc4k(10)};
    text-transform: uppercase;
    font-family: ${fonts.headline};
    font-size: ${calc4k(50)};
    color: #afafaf;
    font-weight: 500;
    margin: ${calc4k(32)} 0 ${calc4k(18)} 0;
    animation: ${fadeOut} 1200ms ease-in-out;
`;

export const Title = styled.h2`
    margin-top: ${calc4k(35)};
    font-family: ${fonts.headline};
    font-weight: 500;
    font-size: ${calc4k(130)};
    line-height: ${calc4k(145)};
    animation: ${fadeOut} 1200ms ease-in-out;
`;
